<template>
    <div class="section-title-default">
        <h2>{{ options[0].title }}</h2>
    </div>
</template>

<script>
    export default {
        name: 'section-title-default',
        props: ['options'],
        data () {
            return {
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/section-title.scss';
    @import '@/styles/components/partials/respond/section-title-respond.scss';
</style>